import { ListingCardMarkerOverlay } from './ListingCardMarkerOverlay';

export class ListingMarketInsightsCardMarkerOverlay extends ListingCardMarkerOverlay {}
